export const defaultAdaptiveCardStyles = {
  background: "white",
  color: "black",
  anchorColor: "blue",
  textWhiteSpace: "normal",
  buttonWhiteSpace: "normal"
};